import type { AdminNatCodesCode, AdminNatCodesFamily, AdminNatCodesGroup } from '#api/tmsApiService'

export type FilterFunctions = {
  groups?: (group: AdminNatCodesGroup) => boolean
  families?: (family: AdminNatCodesFamily) => boolean
  codes?: (code: AdminNatCodesCode) => boolean
  includeEmpty?: boolean
}

export function filterNationalCodesTree(rootGroups: AdminNatCodesGroup[] | undefined, filters: FilterFunctions = {}): AdminNatCodesGroup[] {
  if (!rootGroups) {
    return []
  }

  const { groups: groupFilter, families: familyFilter, codes: codeFilter, includeEmpty = false } = filters

  if (!groupFilter && !familyFilter && !codeFilter) {
    return rootGroups
  }

  const filteredGroups: AdminNatCodesGroup[] = []
  for (const group of rootGroups) {
    const filteredFamilies: AdminNatCodesFamily[] = []

    if (groupFilter && !groupFilter(group)) {
      continue
    }

    if (group.families) {
      for (const family of group.families) {
        const filteredCodes: AdminNatCodesCode[] = []

        if (familyFilter && !familyFilter(family)) {
          continue
        }

        if (family.codes) {
          for (const code of family.codes) {
            if (!codeFilter || codeFilter(code)) {
              filteredCodes.push(code)
            }
          }
        }

        if (includeEmpty || filteredCodes.length > 0) {
          filteredFamilies.push({ ...family, codes: filteredCodes })
        }
      }
    }

    if (includeEmpty || filteredFamilies.length > 0) {
      filteredGroups.push({ ...group, families: filteredFamilies })
    }
  }

  return filteredGroups
}
